import { render } from "./NavBasic.vue?vue&type=template&id=a0597262&scoped=true"
import script from "./NavBasic.vue?vue&type=script&lang=js"
export * from "./NavBasic.vue?vue&type=script&lang=js"

import "./NavBasic.vue?vue&type=style&index=0&id=a0597262&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0597262"]])

export default __exports__